import { ROLES } from "../constants/roles";

class ScopesUtils {
  private static hasScope(scopes: any, scope: string): boolean {
    if (!Array.isArray(scopes)) return false;
    return scopes.includes(scope);
  }

  static FlightReservation = (hasUserAnyAuthority: (a: string[]) => boolean, scopes: any): boolean => {
    if (hasUserAnyAuthority([ROLES.ROLE_ADMIN])) return true;

    if (hasUserAnyAuthority([ROLES.ROLE_AGENT, ROLES.ROLE_CALL_AGENT])) {
      return ScopesUtils.hasScope(scopes, "FLIGHT_RESERVATION");
    }

    return false;
  };

  static AgentPremission = (hasUserAnyAuthority: (a: string[]) => boolean, scopes: any): boolean => {
    if (hasUserAnyAuthority([ROLES.ROLE_ADMIN])) return true;

    if (hasUserAnyAuthority([ROLES.ROLE_AGENT, ROLES.ROLE_CALL_AGENT])) {
      return ScopesUtils.hasScope(scopes, "ALLOW_CREATING_SUB_AGENTS");
    }

    return false;
  };
}

export default ScopesUtils;
